var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrizzle01 = function SvgDrizzle01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.02,
    y1: 175.88,
    x2: 161.25,
    y2: 12.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 60.47,
    y1: 228.79,
    x2: 216.7,
    y2: 65.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 69.41,
    y1: 237.31,
    x2: 225.64,
    y2: 73.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 78.35,
    y1: 245.85,
    x2: 234.59,
    y2: 82.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 56.91,
    y1: 225.39,
    x2: 213.15,
    y2: 61.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 31.91,
    y1: 201.54,
    x2: 188.14,
    y2: 37.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 47.99,
    y1: 216.88,
    x2: 204.23,
    y2: 53.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 64.09,
    y1: 232.24,
    x2: 220.33,
    y2: 68.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 28.36,
    y1: 198.15,
    x2: 184.59,
    y2: 34.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 3.34,
    y1: 174.28,
    x2: 159.58,
    y2: 10.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 19.43,
    y1: 189.64,
    x2: 175.67,
    y2: 25.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 35.53,
    y1: 204.99,
    x2: 191.76,
    y2: 41.23,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M151.19,28.27c-3.14,0-6.36.43-9.75,1.29C133.14,11.5,115.42,0,95.4,0,73.23,0,53.8,14.19,47.05,35.3c-.61,1.91.44,3.95,2.35,4.56,1.92.62,3.95-.44,4.56-2.35,5.79-18.09,22.45-30.25,41.45-30.25,16.88,0,31.86,9.56,39.1,24.65-4.98,2.28-8.43,5.64-10.55,8.33-1.24,1.57-.97,3.86.6,5.1.67.52,1.46.78,2.24.78,1.07,0,2.14-.47,2.85-1.38,1.96-2.49,5.41-5.78,10.68-7.29.02,0,.1-.03.12-.04,3.87-1.26,7.37-1.88,10.72-1.88,19.18,0,34.78,15.6,34.78,34.79s-15.61,34.78-34.78,34.78H40.23c-14.45,0-26.2-11.75-26.2-26.2s11.76-26.2,26.2-26.2c2.13,0,4.36.35,7.01,1.09,3.47,1.05,6.7,2.93,9.08,5.3.71.71,1.63,1.06,2.56,1.06s1.86-.36,2.57-1.07c1.41-1.42,1.41-3.72-.01-5.13-3.22-3.2-7.53-5.73-12.13-7.11-.01,0-.02,0-.04,0-.01,0-.02-.01-.03-.01-3.33-.93-6.19-1.37-9.01-1.37-18.45,0-33.46,15.01-33.46,33.46s15.01,33.46,33.46,33.46h110.95c23.18,0,42.04-18.86,42.04-42.04,0-23.18-18.86-42.05-42.04-42.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.54,135.55c-.71,0-1.42-.14-2.08-.43-.64-.27-1.22-.66-1.72-1.15-2.1-2.09-2.1-5.48-.01-7.57,0,0,0-.01.01-.02.5-.49,1.08-.87,1.72-1.15,1.32-.57,2.83-.57,4.15,0,1.69.72,2.99,2.27,3.29,4.28.24,1.62-.38,3.26-1.54,4.42l-.04.04c-1.01,1-2.37,1.56-3.79,1.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.17,148.09c0-2.97,2.4-5.37,5.37-5.37,2.96.02,5.35,2.41,5.37,5.37-.02,2.96-2.41,5.35-5.37,5.37-2.96,0-5.37-2.39-5.37-5.36h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.54,171.36c-.71,0-1.42-.14-2.08-.43-.64-.27-1.22-.66-1.72-1.15-2.1-2.09-2.1-5.48-.01-7.57,0,0,0-.01.01-.02.5-.49,1.08-.87,1.72-1.15,1.32-.57,2.83-.57,4.15,0,1.69.72,2.99,2.27,3.29,4.28.24,1.62-.38,3.26-1.54,4.42l-.04.04c-1.01,1-2.37,1.56-3.79,1.57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.89,173.15c0-2.97,2.4-5.37,5.37-5.37,2.96.02,5.35,2.41,5.37,5.37-.02,2.96-2.41,5.35-5.37,5.37-2.96,0-5.37-2.39-5.37-5.36h0ZM121.89,151.67c0-2.97,2.4-5.37,5.37-5.37,2.96.02,5.35,2.41,5.37,5.37-.02,2.96-2.41,5.35-5.37,5.37-2.96,0-5.37-2.39-5.37-5.36h0ZM121.89,130.17c0-2.96,2.4-5.36,5.36-5.36h.01c2.96.02,5.35,2.41,5.37,5.37-.02,2.96-2.41,5.35-5.37,5.37-2.96,0-5.37-2.39-5.37-5.36v-.03Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M99.98,135.55c-1.39,0-2.78-.48-3.75-1.48-1.68-1.72-2-4.05-1.18-5.97.27-.64.66-1.22,1.15-1.72,2.07-2.1,5.45-2.12,7.54-.05.51.5.91,1.1,1.18,1.77,1.15,2.72-.12,5.87-2.84,7.02-.66.28-1.37.42-2.09.42h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.61,173.15c0-2.59,1.84-4.87,4.4-5.29.79-.13,1.52-.1,2.34.1,2.37.57,4,2.74,4,5.18h0c-.02,2.97-2.41,5.36-5.37,5.39-2.96,0-5.37-2.39-5.37-5.36h0ZM94.61,151.67c0-2.96,2.39-5.37,5.36-5.37h.01c2.96.02,5.35,2.41,5.37,5.37,0,2.96-2.39,5.37-5.36,5.37h-.01c-2.94.03-5.34-2.33-5.37-5.27v-.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.98,200c-.96,0-1.91-.25-2.71-.77-2.57-1.67-3.19-4.47-2.23-6.67.27-.64.66-1.22,1.15-1.72,2.07-2.1,5.45-2.12,7.54-.05.51.5.91,1.1,1.18,1.77.29.65.44,1.36.44,2.08,0,1.42-.57,2.79-1.57,3.8-1.01.99-2.37,1.56-3.8,1.57Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.32,173.15c.02-2.96,2.41-5.35,5.37-5.37,2.96,0,5.37,2.39,5.37,5.36h0c0,2.61-1.85,4.89-4.41,5.31-.33.05-.64.08-.96.07-2.97,0-5.37-2.4-5.37-5.37M67.32,151.67c.02-2.96,2.41-5.35,5.37-5.37,2.96,0,5.37,2.39,5.37,5.36h0c0,2.98-2.4,5.39-5.37,5.39-2.96-.02-5.35-2.41-5.37-5.37M67.32,130.18c0-2.97,2.4-5.37,5.37-5.37,2.94-.03,5.34,2.33,5.37,5.27,0,.03,0,.07,0,.1,0,2.96-2.39,5.37-5.36,5.37h-.01c-2.96-.02-5.35-2.41-5.37-5.37"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.41,135.55c-.71,0-1.42-.15-2.08-.43-.65-.24-1.24-.64-1.72-1.15-1.01-1.01-1.57-2.37-1.57-3.8,0-.71.14-1.42.42-2.08.54-1.3,1.57-2.33,2.86-2.86,2.73-1.16,5.87.12,7.03,2.85.28.66.42,1.37.42,2.09,0,.72-.15,1.42-.44,2.08-.27.64-.66,1.22-1.14,1.72-1.01,1.01-2.37,1.57-3.8,1.57Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M40.04,173.15c0-2.96,2.39-5.37,5.36-5.37h.01c2.97,0,5.37,2.4,5.37,5.37-.02,2.96-2.41,5.35-5.37,5.37-2.96-.02-5.35-2.41-5.37-5.37M40.04,151.67c.02-2.96,2.41-5.35,5.37-5.37,2.96.02,5.35,2.41,5.37,5.37,0,2.96-2.39,5.37-5.36,5.37h-.01c-2.97,0-5.37-2.4-5.37-5.37Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.41,200c-.71,0-1.42-.15-2.08-.43-.64-.27-1.22-.66-1.72-1.15-2.1-2.09-2.1-5.48-.01-7.57,0,0,0-.01.01-.02.5-.49,1.08-.87,1.72-1.15,1.32-.57,2.83-.57,4.15,0,1.3.53,2.33,1.56,2.86,2.86.58,1.32.58,2.83,0,4.15-.27.64-.65,1.22-1.14,1.72-1.01,1.01-2.38,1.58-3.8,1.57Z"
  })));
};
export default SvgDrizzle01;